var scope_0 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0ad82fac29d04f264579fac65c73ffbd.js').default;
var scope_1 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0bbd956a5490af8e4d10c50353c558c9.js').default;
var scope_2 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1422e7415de78dc708b4f75c345bc1e0.js').default;
var scope_3 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/15649a5cb78b77ba3abe2e7d3501c6eb.js').default;
var scope_4 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/203ec7c7043ffd52102fd3d3151d251f.js').default;
var scope_5 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2308176178e570b5eab12215f2fa7a73.js').default;
var scope_6 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3254c84cf6755c2d9be6639553e4f9d8.js').default;
var scope_7 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3ce31f4ffe8ea5758c8c1f815239816a.js').default;
var scope_8 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/50e582d3bedff9920d36226c04c4f206.js').default;
var scope_9 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/511224286befe81785cb768d0971b3ca.js').default;
var scope_10 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/607473a7fb62119776044932115a260a.js').default;
var scope_11 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6369f4301bff644b4cf42ba018300b46.js').default;
var scope_12 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/63e826cb4fba37b5e73e0015bd50b398.js').default;
var scope_13 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/667c01f603518f735bc3a3630cb65179.js').default;
var scope_14 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/78f67ecec9c3331e5bd8a42d9a93c3bf.js').default;
var scope_15 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8694f55819683c0cbb05b8ebd477819a.js').default;
var scope_16 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/97a01b138c7bb7471be431171be6babd.js').default;
var scope_17 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9b7f846820f2ab8854189f066cecdbb7.js').default;
var scope_18 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9effee218fe7d34f325dd8be661c16fb.js').default;
var scope_19 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bdee32ffea558cd8f242c51cf793ceb5.js').default;
var scope_20 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_21 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ef3da537824dad7a306bdc6af907642c.js').default;
var scope_22 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f74f7d991da14469b4e11c22de3890cb.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20,
scope_21,
scope_22 )
    